module.exports = __webpack_public_path__ + "static/media/blog8.8fcfa86d.jpg";